import { Stack, Typography } from '@mui/material'
import { ChangeTransportSubFormStore } from '@planning/components/organisms/ChangeTransportSubForm'
import { OrderHoldsSection } from '@planning/components/hold/organisms/OrderHoldsSection'
import { OrderHoldsSectionStore } from '@planning/components/hold/organisms/stores/OrderHoldsSectionStore'
import { OrderFormStoreType } from '@planning/pages/Order/V2/stores/OrderFormStore'
import { useTranslate } from '@tolgee/react'
import { IFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { ContainerCardData } from '../molecules/UnitContainerCard'
import { OrderCargoViewCard } from '../organisms/OrderCargoViewCard'
import { OrderNotesCard } from '../organisms/OrderNotesCard'
import { OrderTransportViewCard } from '../organisms/OrderTransportViewCard'
import { OrderUnitViewCard } from '../organisms/OrderUnitViewCard'
import { StepperFormViewStore } from '../StepperFormViewStore'
import { OrderReviewStore } from '../stores/OrderReviewStore'

type Props = {
  containerId: number
  container?: ContainerCardData
  formStore: IFormStore<OrderFormStoreType>
  stepperFormViewStore: StepperFormViewStore
  orderReviewStore: OrderReviewStore
  inboundTransportStore: ChangeTransportSubFormStore
  outboundTransportStore: ChangeTransportSubFormStore
  holdsStore: OrderHoldsSectionStore
}

export type OrderViewCardProps<T> = {
  attributes: T
  allowEdit?: boolean
  hideActions?: boolean
  onClickSave?: () => Promise<void>
  onClickEdit?: () => void
}

export const OrderReviewStep = observer((props: Props) => {
  const {
    container,
    formStore,
    orderReviewStore,
    stepperFormViewStore,
    inboundTransportStore,
    outboundTransportStore,
    holdsStore,
  } = props

  const { t } = useTranslate()

  return (
    <Stack spacing={2}>
      <Typography variant='subtitle1' gutterBottom>
        {t('review', 'Review')}
      </Typography>
      <OrderUnitViewCard container={container} onClickEdit={() => stepperFormViewStore.goTo(0)} />
      <OrderTransportViewCard
        attributes={orderReviewStore.transportData}
        onClickEdit={() => stepperFormViewStore.goTo(1)}
        inboundTransportStore={inboundTransportStore}
        outboundTransportStore={outboundTransportStore}
      />
      <OrderCargoViewCard
        title={t('cargo', 'Cargo')}
        attributes={orderReviewStore.cargoData}
        onClickEdit={() => stepperFormViewStore.goTo(2)}
      />

      <OrderNotesCard formStore={formStore} />
      <OrderHoldsSection store={holdsStore} />
    </Stack>
  )
})
